<template>
    <div>
     <!-- 面包屑导航 -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>专利爬虫记录(监控系统)</el-breadcrumb-item>
     </el-breadcrumb>
     <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.patent_number" style="width:110px" placeholder="输入专利号"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:110px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.zlmc" style="width:110px" placeholder="输入专利名称"></el-input>
      </el-form-item> -->
      <!-- 更新时间 -->
      <el-form-item label="记录状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择推送开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择推送结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
      </el-form-item>
      <el-form-item>
      <el-button size="small" type="danger" title="删除满足条件的数据" @click="delData()">删除</el-button>
      </el-form-item>
      
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="handleExport" title="批量导入监控数据">导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" @click="delMonitorCheck" title="批量删除勾选数据">删除</el-button>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button size="small" type="warning" @click="remindCheck" title="提醒选中的数据">提醒</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column align="center"  label="专利名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="applicationNumber" label="专利号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="案件状态" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" prop="status" :formatter="statusFormat" label="记录状态" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column align="center" prop="add_time" label="推送时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="handle_time" label="处理时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="50">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         <!-- 上传Excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M</div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <!-- 爬虫数据详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog('feeForm')">
        <el-form :model="reptileData" ref="rptileData">
          <el-row>
            <el-col :span="6">
              <el-form-item label="专利名称">
                <el-input size="small" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="专利号">
                <el-input size="small" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="案件状态">
                <el-input size="small" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="主分类号">
                <el-input size="small" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="发明人">
                <el-input size="small" v-model="reptileData.fmr" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请人">
                <el-input size="small" v-model="reptileData.sqr" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="代理人">
                <el-input size="small" v-model="reptileData.dydlr" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="代理机构">
                <el-input size="small" v-model="reptileData.dljgmc" auto-complete="off" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
            <el-table size="small" ref="multipleTable" :data="pay_able" highlight-current-row v-loading="loading" border>
              <el-table-column align="center" prop="yingjiaoffyzlmc" label="类目" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="yingjiaoje" label="金额" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="jiaofeijzr" label="截止日" show-overflow-tooltip>
              </el-table-column>
            </el-table>
            <el-table size="small" ref="multipleTable" :data="payed" highlight-current-row v-loading="loading" border>
              <el-table-column align="center" prop="shoujufwfyzlmc" label="类目" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="shoujufwjfje" label="金额" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="shoujufwjfsj" label="缴费日期" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="shoujufwsjtt" label="缴费人" show-overflow-tooltip>
              </el-table-column>
              <el-table-column align="center" prop="shoujufwsjh" label="收据号" show-overflow-tooltip>
              </el-table-column>
            </el-table>

        
    </el-dialog>

    </div>
</template>

<script>
import { webPatReptileAgencyList, webUrl, webUpdateTrialPat, delPatentReptileAgency } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      excelFormVisible: false, //控制批量导入页面显示与隐藏
      feeFormVisible: false, //控制年费录入页面显示与隐藏
      title: '监控详情',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
       formInline: {
        page: 1,
        ps: 10,
        patent_number: '',
        start_time: '',
        end_time: ''
      },
      feeForm: {
        zlid: '',
        zlmc: ''
      },
      reptileData: {
        fmmc: '',
        sqh: '',
        sqr: '',
        fmr: '',
        dlr: '',
        ajzt: '',
        zflh: '',
        dljgmc: '',
        sqri: ''
      },
      pay_able: [],
      payed: [],
      // annualFeeForm: {
      //     zlid: '',
      //     pay_able: [{
      //       name: '',
      //       date: ''
      //     }],
      //   },
    status: [
        { key: '全部', value: 0 },
        { key: '已推送', value: 1 },
        { key: '已拉取', value: 2 },
        { key: '已处理', value: 3 },
        { key: '其他状态', value: 4 }
      ],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/monitor/importTrialPat',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if(parameter.start_time == null){
            parameter.start_time = 0
      }
      if(parameter.end_time == null){
            parameter.end_time = 0
      }
      webPatReptileAgencyList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
            console.log(this.listData)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 删除数据
    delData() {
      let parameter = this.formInline
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if(parameter.start_time == null){
            parameter.start_time = 0
      }
      if(parameter.end_time == null){
            parameter.end_time = 0
      }
    this.$confirm('确定删除所有满足条件的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPatentReptileAgency(parameter)
          .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
                this.getdata(parameter)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      // console.log(row)
      if(row.isEmpty != 'Y'){
        this.$message({
              type: 'info',
              message: '当前状态不支持查看详情!'
            })
        return false
      }
      this.title = '爬虫记录详情'
      this.editFormVisible = true
      this.reptileData = row.sqxx.data
      this.pay_able = row.fyxx.data.yingjiaofei.svYingjfList
      this.payed = row.fyxx.data.shoujufawen.svSjfwList
      // console.log(this.pay_able)
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
     //根据不同值显示不同文本内容
    statusFormat(row,column){
      if(row.status == 1){
          return '已推送'
      }else if(row.status == 2){
          return '已拉取'
      }else if(row.status == 3){
          return '已处理'
      }else if(row.status == 4){
          return '其他状态'
      }
    },
    // 发送提醒
        //显示年费录入界面
    handleInput: function(index,row){
        if(row.status == 4 || row.status == 5){
            this.$message({
                type: 'info',
                message: '该状态不支持录入!'
            })
            return false
        }
        this.title = '进度录入'
        this.feeFormVisible = true
        this.feeForm = row
        this.annualFeeForm.zlid = row.zlid
        if(row.trial_data !== null){
        this.annualFeeForm.pay_able = row.trial_data
        }else{
          // 没有数据需要初始化,防止之前的数据回显
         this.annualFeeForm.pay_able = [{
            name: '专利受理',
            date: ''
          },{
            name: '初步审查合格',
            date: ''
          },{
            name: '进入实质审查',
            date: ''
          },{
            name: '第一次审查意见',
            date: ''
          },{
            name: '第N次审查意见',
            date: ''
          },{
            name: '授权待登记',
            date: ''
          },{
            name: '驳回待复审',
            date: ''
          },{
            name: '专利权维持',
            date: ''
          }]
        }
    },
    submitFeeForm(formName) {
      // 需要确认
      this.$confirm('确定提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$refs[formName].validate((valid) => {
      console.log(valid)
      if (valid) {
      const param = { zlid:this.annualFeeForm.zlid,pay_able:JSON.stringify(this.annualFeeForm.pay_able) }
      webUpdateTrialPat(param)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.feeFormVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        })
      })
  },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      if (index !== -1) {
        this.annualFeeForm.pay_able.splice(index, 1)
      }
    },
    // 当前节点添加输入行
    addOnNodeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      this.annualFeeForm.pay_able.splice(index, 0,{key: Date.now()})
    },
    addNextNodeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      this.annualFeeForm.pay_able.splice(index+1, 0,{key: Date.now()})
    },
    addDomain() {
      this.annualFeeForm.pay_able.push({
        key: Date.now()
      });
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/patent/ReptileAgency.vue